"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAxiosClient = exports.isAxiosClientError = void 0;
const axios_1 = __importStar(require("axios"));
const stream_1 = require("stream");
const httpError_1 = require("./httpError");
const CORRELATION_ID = 'X-Correlation-Id';
const CALLER_ID = 'X-Caller-Id';
const LOCALE = 'Idf-Locale';
function isAxiosClientError(error) {
    if (!error) {
        return false;
    }
    return (error === null || error === void 0 ? void 0 : error.isAxiosError) === true;
}
exports.isAxiosClientError = isAxiosClientError;
function createAxiosClient(apiHost, options) {
    var _a;
    const client = axios_1.default.create({
        baseURL: `${apiHost}`,
        timeout: options.timeout,
        headers: {
            Accept: (_a = options.accept) !== null && _a !== void 0 ? _a : 'application/json',
        },
    });
    function accessTokenInterceptor() {
        return __awaiter(this, void 0, void 0, function* () {
            if (options.accessTokenSource !== undefined) {
                const accessToken = yield options.accessTokenSource();
                if (accessToken !== null) {
                    return new axios_1.AxiosHeaders({ Authorization: `Bearer ${accessToken}` });
                }
            }
            return new axios_1.AxiosHeaders();
        });
    }
    function correlationIdInterceptor() {
        return __awaiter(this, void 0, void 0, function* () {
            if (options.correlationIdSource !== undefined) {
                const correlationId = yield options.correlationIdSource();
                if (correlationId !== null) {
                    return new axios_1.AxiosHeaders({ [CORRELATION_ID]: correlationId });
                }
            }
            return new axios_1.AxiosHeaders();
        });
    }
    function callerIdInterceptor() {
        const { callerId } = options;
        if (callerId !== null) {
            return new axios_1.AxiosHeaders({ [CALLER_ID]: callerId });
        }
        return new axios_1.AxiosHeaders();
    }
    function localeSourceInterceptor() {
        const { localeSource } = options;
        if (localeSource) {
            return new axios_1.AxiosHeaders({ [LOCALE]: localeSource() });
        }
        return new axios_1.AxiosHeaders();
    }
    client.interceptors.request.use((config) => __awaiter(this, void 0, void 0, function* () {
        const tokenHeader = yield accessTokenInterceptor();
        const correlationIdHeader = yield correlationIdInterceptor();
        const callerIdHeader = callerIdInterceptor();
        const localeHeader = localeSourceInterceptor();
        const headers = config.headers.concat(tokenHeader, correlationIdHeader, callerIdHeader, localeHeader);
        return Object.assign(Object.assign({}, config), { headers });
    }));
    client.interceptors.response.use(undefined, (error) => {
        var _a, _b;
        if (isAxiosClientError(error) && options.useHttpError === true) {
            const unStreamedData = ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) instanceof stream_1.Readable ? error.response.data.toArray() : Promise.resolve((_b = error.response) === null || _b === void 0 ? void 0 : _b.data);
            return unStreamedData.then((data) => {
                throw new httpError_1.HttpError(error, data);
            });
        }
        return Promise.reject(error);
    });
    return client;
}
exports.createAxiosClient = createAxiosClient;
//# sourceMappingURL=data:application/json;base64,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